// import { login, getInfo } from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  saveSetting,
  setUserInfo,
  removeSetting,
  removeUserInfo,
  clearAll,
} from '@/utils/auth'
import { setLocalStorage, getLocalStorage, clearLocalStorage } from '@/utils/storage'
import { resetRouter } from '@/router'
import { TenantExtendServiceProxy,TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { loginByUsername } from '@/api/api'
import store from '../index'
import { getUserInfo } from '@/utils/auth'
import { message } from 'ant-design-vue'
import i18n from '@/locales'
import { tdTracking } from '@/utils/index'

const state = {
  token: getToken(),
  apps: [],
  permissions: [],
  settings: {},
  userSettings: {}, // 用户个性化设置
  user: {},
  drawer: [],
  isHost: getLocalStorage('isHost') || false,
  drawerId: '',
}
// 判断是否为有效的二级域名
const isValidTennat = (tennat: string) => {
  if (!isNaN(parseInt(tennat))) {
    return false
  }
  if (tennat === 'www') {
    return false
  }
  return true
}
const mutations = {
  SET_TOKEN: (state: any, token: any) => {
    state.token = token
  },
  SET_APPS: (state: any, apps: any) => {
    state.apps = apps
  },
  SET_ISHOST: (state: any, tenantId: any) => {
    state.isHost = tenantId === '000000'
    setLocalStorage('isHost', state.isHost)
  },
  SET_PERMISSIONS: (state: any, permissions: any) => {
    state.permissions = permissions
  },
  SET_SETTINGS: (state: any, settings: any) => {
    state.settings = settings
  },
  SET_USER_SETTINGS: (state: any, userSettings: any) => {
    state.userSettings = userSettings
  },
  SET_USER: (state: any, user: any) => {
    state.user = user
    setUserInfo(user)
  },
  ALL_CLEAR: (state: any, without: Array<string>) => {
    state.token = ''
    state.apps = []
    state.permissions = []
    state.settings = {}
    state.userSettings = {}
    store.state.permission.appRoutes = []
    store.state.app.current = null
    store.state.app.appName = null
    state.user = {}
    state.isHost = false
    clearLocalStorage(without)
    state.drawer = []
    state.drawerId = ''
  },
  SET_DRAWER(state, drawer) {
    state.drawer = drawer
  },
  ADD_DRAWER: (state: any, item: any) => {
    state.drawer.push(item)
  },
  DEL_DRAWER: (state: any, link: any) => {
    state.drawer = state.drawer.filter((item: any) => {
      return item.link !== link
    })
  },
  SET_DRAWER_ID(state, id) {
    state.drawerId = id
  },
}
const serviceProxy = new TenantExtendServiceProxy()
const actions = {
  // 根据二级域名获取个性化设置,仅在登录页面使用
  getSettingByDomainUsingGET({ commit }: any) {
    const h = location.href.split('.')[0]
    const domain = h.split('//')[1]
    if (isValidTennat(domain)) {
      serviceProxy.getSettingByDomain(domain).then(res => {
        if (res) {
          // commit('SET_SETTINGS', res)
          commit('SET_USER_SETTINGS', res)
        }
      })
    }
  },

  // 直接根据token获取个性化设置，在非登录页面使用
  getSetting({ commit }: any) {
    return new Promise((resolve, reject) => {
      serviceProxy
        .detail()
        .then(res => {
          if (res) {
            // commit('SET_SETTINGS', res)
            commit('SET_USER_SETTINGS', res)
            saveSetting(res)
            console.log('re', res)
            resolve(res)
          }
        })
        .catch(res => {
          // resolve(res)
          throw res
        })
    })
  },

  // user login
  login({ commit }: any, userInfo: any) {
    const { tenantId, username, password, type, grantType, refresh_token, socialId, code } = userInfo
    return new Promise((resolve, reject) => {
      loginByUsername(tenantId, username, password, grantType, refresh_token, code, socialId)
        .then((response: any) => {
          var kv = {}
          var kv2 = {}
          kv[tenantId] = 1
          kv2[`${tenantId}_${username}`] = 1
          tdTracking('tenant_login',  kv)
          tdTracking('account_login',  kv2)
          const { access_token, tenant_id } = response
          setToken(access_token)
          commit('SET_TOKEN', access_token)
          commit('SET_USER', response)
          commit('SET_ISHOST', tenant_id)
          resolve(response)
        })
        .catch((error: any) => {
          reject(error)
        })



    })
  },

  // user logout
  logout({ commit, dispatch }: any) {
    commit('i18n/CLEAR_LOADED_LANGUAGES', null, { root: true })
    commit('ALL_CLEAR', ['lang'])
    removeToken()
    resetRouter()
    removeSetting()
    removeUserInfo()
    clearAll()
    dispatch('tagsView/delAllViews', null, { root: true })
  },

  // remove token
  resetToken({ commit }: any) { 
    return new Promise(resolve => {
      commit('ALL_CLEAR', ['lang'])
      removeToken()
      resolve()
    })
  },

  async putInDrawer({ commit, state }: any, { app, icon,name, route }: any) {
    const item = {
      icon: icon,
      app: app,
      title: route.name,
      link: route.data.path,
      name: name,
      code: route.data.code
    }
    console.log(item,state,'item')
    const tssp = new TenantSettingServiceProxy()
    const userId = getUserInfo().user_id
    const body: any = {
      id: state.drawerId,
      paramName: 'location-label',
      paramKey: userId,
      paramValue: JSON.stringify([...state.drawer, item]),
      // paramValue: ''
    }
    try {
      await tssp.submit(body)
      message.success(i18n.t('page_mdc_realtime_success'))
      commit('ADD_DRAWER', item)
    } catch (e) {
      message.error(i18n.t('page_log_management_fail'))
    }
  },

  async takeFromDrawer({ commit, state }: any, link: any) {
    const tssp = new TenantSettingServiceProxy()
    const userId = getUserInfo().user_id
    const body: any = {
      id: state.drawerId,
      paramName: 'location-label',
      paramKey: userId,
      paramValue: JSON.stringify(state.drawer.filter(item => item.link !== link)),
      // paramValue: ''
    }
    try {
      await tssp.submit(body)
      message.success(i18n.t('page_mdc_realtime_success'))
      commit('DEL_DRAWER', link)
    } catch (e) {
      message.error(i18n.t('page_log_management_fail'))
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
